export default {
    "title": "Consulta tus puntos y recompensas con tu teléfono.",
    "phoneLabel": "Ingresa tu número de teléfono",
    "phonePlaceholder": "(99) 9 9999-9999",
    "enterButton": "Entrar",
    "step2Message1": "Estamos enviando un código a su teléfono móvil por SMS, puede tardar hasta 3 minutos en llegar.",
    "step2Message2": "Le hemos enviado otro SMS, si no lo recibe, por favor informe del incidente a nuestro establecimiento.",
    "authCode": "Código de Autenticación",
    "resendButton": "Enviar de nuevo",
    "resendWait": "Reenviar en {seconds}s",
    "codeLabel": "Código de confirmación",
    "codePlaceholder": "Ingrese el código aquí",
    "verifyButton": "Verificar",
    "backButton": "Volver",
    "signupTitle": "No encontramos su teléfono, por favor complete el formulario para registrarse.",
    "firstNameLabel": "Nombre",
    "firstNamePlaceholder": "Ingrese su nombre",
    "lastNameLabel": "Apellido",
    "lastNamePlaceholder": "Ingrese su apellido",
    "birthdateLabel": "Fecha de nacimiento",
    "birthdatePlaceholder": "DD/MM/AAAA",
    "emailLabel": "Su correo",
    "emailPlaceholder": "email@email.com",
    "signUpButton": "Registrarse",
    "errorUnknown": "Ocurrió un error desconocido, inténtalo más tarde.",
    "errorPhoneNotFound": "Parece que nunca hiciste un pedido aquí, ¡te estamos esperando!",
    "errorInvalidCode": "El código ingresado no es válido, inténtalo de nuevo."
};
